import IAddress from "@models/IAddress";
import INewAddress from "@models/INewAddress";
import { IOption } from "@models/IOption";

export default class HelperService {
    static toArrayBuffer = (buf: Buffer): ArrayBuffer => {
        const ab = new ArrayBuffer(buf.length);
        const view = new Uint8Array(ab);
        for (let i = 0; i < buf.length; ++i) {
            view[i] = buf[i];
        }
        return ab;
    };

    static getUsStates = () => {
        return [
            { title: "AL", value: "AL" },
            { title: "AK", value: "AK" },
            { title: "AZ", value: "AZ" },
            { title: "AR", value: "AR" },
            { title: "CA", value: "CA" },
            { title: "CO", value: "CO" },
            { title: "CT", value: "CT" },
            { title: "DE", value: "DE" },
            { title: "FL", value: "FL" },
            { title: "GA", value: "GA" },
            { title: "HI", value: "HI" },
            { title: "ID", value: "ID" },
            { title: "IL", value: "IL" },
            { title: "IN", value: "IN" },
            { title: "IA", value: "IA" },
            { title: "KS", value: "KS" },
            { title: "KY", value: "KY" },
            { title: "LA", value: "LA" },
            { title: "ME", value: "ME" },
            { title: "MD", value: "MD" },
            { title: "MA", value: "MA" },
            { title: "MI", value: "MI" },
            { title: "MN", value: "MN" },
            { title: "MS", value: "MS" },
            { title: "MO", value: "MO" },
            { title: "MT", value: "MT" },
            { title: "NE", value: "NE" },
            { title: "NV", value: "NV" },
            { title: "NH", value: "NH" },
            { title: "NJ", value: "NJ" },
            { title: "NM", value: "NM" },
            { title: "NY", value: "NY" },
            { title: "NC", value: "NC" },
            { title: "ND", value: "ND" },
            { title: "OH", value: "OH" },
            { title: "OK", value: "OK" },
            { title: "OR", value: "OR" },
            { title: "PA", value: "PA" },
            { title: "RI", value: "RI" },
            { title: "SC", value: "SC" },
            { title: "SD", value: "SD" },
            { title: "TN", value: "TN" },
            { title: "TX", value: "TX" },
            { title: "UT", value: "UT" },
            { title: "VT", value: "VT" },
            { title: "VA", value: "VA" },
            { title: "WA", value: "WA" },
            { title: "WV", value: "WV" },
            { title: "WI", value: "WI" },
            { title: "WY", value: "WY" },
        ];
    };

    /**
     * Validates an email address
     *
     * Returns true if the email address is valid, false otherwise
     *
     * @param emailAddress
     */
    static validateEmailAddress = (emailAddress: string): boolean => {
        // we need to check if the email address is a series seperated by a comma or a semicolon
        // if it is, we need to split it into an array and check each email address
        if (emailAddress.indexOf(",") !== -1 || emailAddress.indexOf(";") !== -1) {
            const splitChar = emailAddress.indexOf(",") !== -1 ? "," : ";";
            const emails = emailAddress.split(splitChar);
            for (const email of emails) {
                if (!this.validateEmailAddress(email)) {
                    return false;
                }
            }
            return true;
        }

        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(emailAddress.trim()).toLowerCase());
    };

    static formatCurrency = ({
        value = 0,
        precision = 2,
        currency = "USD",
    }: {
        value?: number;
        precision?: number;
        currency?: string;
    } = {}): string => {
        const currencyFormatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: precision,
        });

        return currencyFormatter.format(value);
    };

    static getMonthsOptionsArray = (): IOption[] => {
        return [
            { value: "01", label: "January" },
            { value: "02", label: "February" },
            { value: "03", label: "March" },
            { value: "04", label: "April" },
            { value: "05", label: "May" },
            { value: "06", label: "June" },
            { value: "07", label: "July" },
            { value: "08", label: "August" },
            { value: "09", label: "September" },
            { value: "10", label: "October" },
            { value: "11", label: "November" },
            { value: "12", label: "December" },
        ];
    };

    static getMonthsNumberOptionsArray = (): IOption[] => {
        return [
            { value: "01", label: "01" },
            { value: "02", label: "02" },
            { value: "03", label: "03" },
            { value: "04", label: "04" },
            { value: "05", label: "05" },
            { value: "06", label: "06" },
            { value: "07", label: "07" },
            { value: "08", label: "08" },
            { value: "09", label: "09" },
            { value: "10", label: "10" },
            { value: "11", label: "11" },
            { value: "12", label: "12" },
        ];
    };

    static getYearsOptionsArray = (): IOption[] => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = 0; i < 10; i++) {
            years.push({ value: (currentYear + i).toString(), label: (currentYear + i).toString() });
        }   
        return years;
    };
}
